import { ReactNode } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { Trash2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import AssignmentEntityChip from './AssignmentEntityChip'

type Props = {
  sortableId: string
  label: ReactNode
  index: number
  canEdit: boolean
  warning?: boolean
  info?: boolean
  warningSlot?: ReactNode
  offsetSeconds?: number
  cascadeSeconds?: number
  onRemove?: () => void
  onClick?: () => void
}

const AssignmentDraggableEntityChip = ({
  sortableId,
  label,
  index,
  canEdit,
  warning,
  info,
  warningSlot,
  offsetSeconds,
  cascadeSeconds,
  onRemove,
  onClick,
}: Props) => {
  const {
    attributes,
    listeners,
    setActivatorNodeRef,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: sortableId,
    disabled: !canEdit,
  })
  return (
    <div
      ref={setNodeRef}
      className='min-w-0 w-full'
      onClick={(event) => {
        event.stopPropagation()
        onClick?.()
      }}
      style={{
        transform: transform
          ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
          : undefined,
        transition,
        opacity: isDragging ? 0 : 1,
        zIndex: isDragging ? 10 : undefined,
      }}
    >
      <div
        ref={setActivatorNodeRef}
        className={cn(
          'min-w-0 w-full',
          canEdit && 'cursor-grab active:cursor-grabbing',
        )}
        {...(canEdit ? attributes : {})}
        {...(canEdit ? listeners : {})}
      >
        <AssignmentEntityChip
          index={index}
          label={label}
          className='w-full'
          warning={warning}
          info={info}
          offsetSeconds={offsetSeconds}
          cascadeSeconds={cascadeSeconds}
          endSlot={
            (canEdit && onRemove) || warningSlot ? (
              <span className='inline-flex items-center'>
                {warningSlot}
                {canEdit && onRemove ? (
                  <Trash2
                    className='h-5 w-5 cursor-pointer px-1 text-muted-foreground hover:text-destructive-foreground transition-colors'
                    onPointerDown={(event) => event.stopPropagation()}
                    onClick={(event) => {
                      event.stopPropagation()
                      onRemove()
                    }}
                  />
                ) : null}
              </span>
            ) : undefined
          }
        />
      </div>
    </div>
  )
}

export default AssignmentDraggableEntityChip
